<template>
  <transition name="fade" mode="out-in">
    <div>
      <summary-page v-if="summary_page"></summary-page>
      <loading-screen v-show="loading && !summary_page"></loading-screen>
      <main-view v-show="!loading && !summary_page && !client_page"></main-view>
      <client-main-view v-show="client_page"></client-main-view>
    </div>
  </transition>
</template>

<script>
  import LoadingScreen from './components/LoadingScreen.vue'
  import MainView from './views/Main.vue'
  import ClientMainView from './views/Client/Main.vue'
  import SummaryPage from './views/ProposalTemplate/Summary.vue'

  import {mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    components: {
      LoadingScreen,
      MainView,
      ClientMainView,
      SummaryPage
    },
    created() {
      if (this.$route.name === 'proposal.summary') {
        this.summary_page = true
      }

      if (this.client_pages.includes(this.$route.name) && !this.authCheck) {
        this.client_page = true
        $('html').addClass('client-page');
      } else {
        this.client_page = false
        $('html').removeClass('client-page');
      }

      this.$root.$on('loading-page', value => {
        this.loading = value
      })

      const token = /token=(.*);?/.exec(document.cookie)
      // if token doesn't exists redirect to login
      if (token) {
        this.loading = true
        this.storeToken(token[1])

        // if token exists check if it is valid
        this.axios.post('/refresh')
          .then(res => {
            this.storeToken(res.data.access_token)
            this.storeTokenInCookie({token: res.data.access_token, expiresIn: res.data.expires_in})
            this.setTimerForTokenRefresh(res.data.expires_in)

            // if token is valid fetch user and redirect it to his initial path
            // route guards now will handle his permissions for the URL
            this.axios.get('/me')
              .then(res => {
                this.storeUser(res.data.data)
                this.loading = false

                // route is stored at auth middleware @router/middlewares.js/auth()
                //this.$router.push({name: this.initialRoute.name})
              })
              .catch(error => {
                this.clearUser()
              })

          })
          .catch(errors => {
            this.clearUser()
            this.$router.push({name: 'login'})
          })
      } else {
//        this.$router.push({name: 'login'})
      }

    },
    data() {
      return {
        loading: false,
        summary_page: false,
        client_page: false,
        client_pages: ['quotes.create', 'quotes.retrieve', 'orders.index', 'orders.success', 'results.index']
      }
    },
    methods: {
      ...mapMutations('auth', ['storeToken', 'storeUser']),
      ...mapActions('auth', ['clearUser', 'storeTokenInCookie', 'setTimerForTokenRefresh']),
    },
    computed: {
      ...mapGetters('auth', ['initialRoute', 'authCheck'])
    },
    watch: {
      '$route': function() {
        if (this.client_pages.includes(this.$route.name) && !this.authCheck) {
          this.client_page = true
          $('html').addClass('client-page');
        } else {
          this.client_page = false
          $('html').removeClass('client-page');
        }
      }
    }
  }
</script>
<style lang="scss">
  .inputPanel__errorMsg:before {
    background: url("./../static/styles/mailkit/img/warning.png") !important;
    content: "";
    position: absolute;
    left: -3.8125rem;
    top: 2.100rem;
    width: 3.875rem;
    height: 3.875rem;
    background-size: contain;
  }

  .inputPanel__errorMsg {
    display: none;
  }

  .inputPanel__error {
    .inputPanel__errorMsg {
      display: block;
    }
  }

  select { outline:none; }


</style>



// WEBPACK FOOTER //
// src/App.vue